export default "__VITE_ASSET__12d2db68__"